<template>
  <RouterLink
    @click.native="onClick"
    class="dropdown__item"
    :class="{ 'has-separator': item.separator }"
    :style="item.cssStyle"
    :tag="tag"
    :to="item.route ? item.route : {}"
  >
    <i v-if="item.icon" :class="item.icon" />
    {{ L(item.text) }}
  </RouterLink>
</template>

<script>
export default {
  name: "DropdownItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      default: () => "li"
    },
    cssStyle: {
      type: Object,
      required: false
    }
  },
  methods: {
    onClick(e) {
      e.preventDefault();
      if (this.item.onClick) return this.item.onClick(e);
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown__item {
  padding: 0.6em 1em;
  cursor: pointer;
}
.dropdown__item.has-separator {
  border-top: solid 1px #0000000f;
}
i {
  margin-right: 1em;
}
.dropdown__item:hover {
  background-color: #0000000f;
}
</style>
